import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  children: React.ReactNode;
  icon?: IconProp;
  iconStyle?: React.CSSProperties;
  style?: React.CSSProperties;
}

const ContentValue = ({ children, icon, iconStyle, style }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="content-value" style={style}>
      {icon ? (
        <div className="icon" style={iconStyle}>
          <Icon icon={icon} />
        </div>
      ) : null}

      {children}

      <style jsx>{`
        .content-value {
          align-items: flex-start;
          color: ${theme.textColor};
          display: inline-flex;
          font-size: 1.6rem;
          font-weight: 400;
        }
        .icon {
          color: ${theme.textColor};
          font-size: 1.4rem;
          margin-right: 8px;
          margin-top: 1px;
          position: relative;
        }
      `}</style>
    </div>
  );
};

export default ContentValue;
